module.exports = __webpack_public_path__ + "img/hyu_gallery5.4f2c51b5.jpg";